
<template>
  <script v-html="this.jsonlddados" type="application/ld+json"></script>
</template>

<script>
export default {
  data () {
      return {
      jsonlddados : {
        "@context": "https://schema.org",
        "@type": "Organization",
        "url": "https://www.aldo.com.br",
        "logo": "https://www.aldo.com.br/assets/images/logo-top-1.png",
        "description": "Maior Distribuidor de Energia Solar do Brasil",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Maringa, Parana",
            "postalCode": "86045237",
            "streetAddress": "Av. Advogado Horácio Raccanello Filho, 1836"
          },
          "email": "cartas@aldo.com.br",
          "faxNumber": "+55 44 3261-2000",
          "name" : "Aldo Componentes",
          "alternateName": "Aldo Solar",
          "telephone": "+55 44 3261-2000",
          }
      }
  }
}
</script>